import * as types from './types';
import { showError } from '../util/errorPopupUtil';
import { processCouponCodeType } from '../util/dataObjectToStoreObject';
import { fetchCouponCodeTypes } from '../api/partner';

const hydrateCouponCodeTypes = (couponCodeTypes) => ({
  type: types.HYDRATE_COUPON_CODE_TYPES,
  couponCodeTypes,
});

export const loadCouponCodeTypes = (simplrAccountId) => {
  return async (dispatch) => {
    try {
      const parseCouponCodeTypes = await fetchCouponCodeTypes(simplrAccountId);
      dispatch(hydrateCouponCodeTypes(parseCouponCodeTypes.map(processCouponCodeType)));
    } catch (e) {
      // protects against stale data
      dispatch(hydrateCouponCodeTypes([]));
      showError(e);
    }
  };
};
